import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const CONFIG = {
  privacy: { title: "Privacy Policy", keys: ["privacy_policy", "electronic_consent", "sms_consent"], labels: ["Privacy Policy", "Electronic Communications Consent", "SMS Consent"] },
  terms: { title: "Terms of Use", keys: ["terms_of_use"], labels: ["Terms of Use"] },
  disclosures: { title: "Disclosures", keys: ["general_disclosure", "state_disclosures", "licenses", "states_served"], labels: ["General Disclosure", "State Disclosures", "Licenses", "States Served"] },
};

export default function LegalPage({ kind }) {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data)).catch(() => {}); }, []);
  const cfg = CONFIG[kind];

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-16" data-testid={`legal-${kind}`}>
      <div className="eyebrow mb-3">Legal</div>
      <h1 className="h-display text-4xl sm:text-5xl text-white">{cfg.title}</h1>
      <div className="mt-8 space-y-8">
        {cfg.keys.map((k, i) => (
          s?.[k] ? (
            <div key={k}>
              <h2 className="text-lg font-bold text-white mb-2">{cfg.labels[i]}</h2>
              <p className="text-sm text-dim leading-relaxed whitespace-pre-wrap">{s[k]}</p>
            </div>
          ) : null
        ))}
        {s && (
          <div className="pt-6 border-t border-edge text-sm text-faint space-y-1">
            {s.legal_entity_name && <p>{s.legal_entity_name}</p>}
            {s.business_address && <p>{s.business_address}</p>}
            {s.nmls_number && <p>NMLS #{s.nmls_number}</p>}
            {s.email && <p>{s.email}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
